import { clsx, type ClassValue } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

// The repo's elevation scale (DESIGN.md §1.1) defines custom `shadow-1` /
// `shadow-2` utilities (tailwind.config.js boxShadow). Stock tailwind-merge
// doesn't know them as box-shadow SIZES — it buckets them as shadow COLORS —
// so e.g. cn('shadow-lg', 'shadow-2') kept BOTH classes and compiled-CSS
// order (not call-site order) picked the winner. Registering them in the
// `shadow` class group makes them conflict-resolve against
// shadow-sm/shadow-lg/… like any other shadow utility: last one wins.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      shadow: [{ shadow: ["1", "2"] }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
